/* eslint-disable */
const defaultFeatureTypes = {
    "BACKPACK": [
        "AESTHETIC",
        "COMFORT",
        "DURABLE",
        "POCKET",
        "MOUNTS"
    ],
    "BAG": [
        "AESTHETIC",
        "COMFORT",
        "DURABLE",
        "POCKET"
    ],
    "BAR-TAPE": [
        "AESTHETIC",
        "COMFORT",
        "DURABLE",
        "PERFORMANCE"
    ],
    "BASE-LAYER": [
        "AESTHETIC",
        "COMFORT",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "BIB-SHORT": [
        "AESTHETIC",
        "COMFORT",
        "CHAMOIS",
        "WICKING",
        "PERFORMANCE",
        "BREATHABLE"
    ],
    "BIB-TIGHT": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "BIDON": [
        "AESTHETIC",
        "DURABLE",
        "CLOSURE"
    ],
    "BMX": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "CONNECTIVITY",
        "PERFORMANCE"
    ],
    "BOOK": [
        "LIGHTWEIGHT",
        "MATERIAL-QUALITY",
        "AESTHETIC",
        "CHAMOIS",
        "CLOSURE",
        "DURABLE",
        "LENS-WIPE",
        "TOUCH-SCREEN-COMPATIBLE",
        "SUN-PROTECTION"
    ],
    "BOTTLE": [
        "AESTHETIC",
        "DURABLE",
        "CLOSURE"
    ],
    "BRAKE": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "PERFORMANCE"
    ],
    "CABLE": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "DURABLE"
    ],
    "CAP": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION"
    ],
    "CASE": [
        "AESTHETIC"
    ],
    "CASSETTE": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "CHAIN": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "CHAINRING": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "CHAINSET": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "CLEANING": [
        "AESTHETIC",
        "PERFORMANCE"
    ],
    "COMMUTER-BIKE": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "CONNECTIVITY",
        "PERFORMANCE",
        "DURABLE"
    ],
    "COMPUTER": [
        "AESTHETIC",
        "CONNECTIVITY",
        "PERFORMANCE"
    ],
    "CYCLOCROSS-BIKE": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "CONNECTIVITY",
        "PERFORMANCE"
    ],
    "DEFAULT": [
        "DESIGN",
        "COMFORT",
        "PERFORMANCE",
        "BREATHABLE",
        "WARMTH"
    ],
    "DRIVETRAIN": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "ELECTRIC-MOUNTAIN-BIKE": [
        "AESTHETIC",
        "RANGE",
        "CONNECTIVITY",
        "PERFORMANCE",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "ELECTRIC-ROAD-BIKE": [
        "AESTHETIC",
        "RANGE",
        "LIGHTWEIGHT",
        "PERFORMANCE",
        "DURABLE"
    ],
    "EYEWEAR": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "LENS",
        "VENTILATION"
    ],
    "FRAME": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "CONNECTIVITY",
        "PERFORMANCE",
        "DURABLE"
    ],
    "FULL-SUSPENSION-MOUNTAIN-BIKE": [
        "AESTHETIC",
        "LIGHTWEIGHT",
        "CONNECTIVITY",
        "PERFORMANCE",
        "DURABLE"
    ],
    "GEARS": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT"
    ],
    "GILET": [
        "AESTHETIC",
        "COMFORT",
        "INSULATION",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "GLASSES": [
        "AESTHETIC",
        "PROTECTION",
        "LENS",
        "DURABLE",
        "VENTILATION"
    ],
    "GLOVE": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE",
        "DURABLE",
        "TOUCH-SCREEN-COMPATIBLE"
    ],
    "GOGGLE": [
        "AESTHETIC",
        "PROTECTION",
        "LENS",
        "DURABLE",
        "VENTILATION"
    ],
    "GPS": [
        "AESTHETIC"
    ],
    "HANDLEBAR": [
        "AESTHETIC"
    ],
    "HARD-TAIL-MOUNTAIN-BIKE": [
        "AESTHETIC"
    ],
    "HAT": [
        "AESTHETIC"
    ],
    "HELMET": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "PERFORMANCE",
        "VENTILATION"
    ],
    "HELMET-ACCESSORY": [
        "AESTHETIC",
        "CONNECTIVITY",
        "PERFORMANCE",
        "VENTILATION"
    ],
    "HYDRATION-DEVICE": [
        "AESTHETIC",
        "CONNECTIVITY",
        "COMPATIBILITY"
    ],
    "INNER-TUBE": [
        "AESTHETIC"
    ],
    "JACKET": [
        "AESTHETIC",
        "COMFORT",
        "INSULATION",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "JERSEY": [
        "AESTHETIC",
        "COMFORT",
        "WICKING",
        "PERFORMANCE",
        "BREATHABLE"
    ],
    "JERSEY-AND-BIB-SHORT": [
        "AESTHETIC",
        "COMFORT",
        "WICKING",
        "PERFORMANCE",
        "BREATHABLE"
    ],
    "JUMPER": [
        "AESTHETIC"
    ],
    "KIDS-BIKE": [
        "AESTHETIC"
    ],
    "KNEE-WARMER": [
        "AESTHETIC",
        "COMFORT",
        "INSULATION",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "LEG-WARMER": [
        "AESTHETIC",
        "COMFORT",
        "INSULATION",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "LIGHT": [
        "AESTHETIC"
    ],
    "LONG-SLEEVE-JERSEY": [
        "AESTHETIC",
        "COMFORT",
        "WICKING",
        "PERFORMANCE",
        "BREATHABLE"
    ],
    "MEMBERSHIP": [],
    "MOUNTAIN-BIKE": [
        "AESTHETIC"
    ],
    "NECK-WARMER": [
        "AESTHETIC"
    ],
    "OIL": [
        "AESTHETIC"
    ],
    "PANT": [
        "AESTHETIC"
    ],
    "PEDALS": [
        "AESTHETIC"
    ],
    "PHONE-POCKET": [
        "AESTHETIC"
    ],
    "POUCH": [
        "AESTHETIC"
    ],
    "PUMP": [
        "AESTHETIC"
    ],
    "PUNCTURE-REPAIR": [
        "AESTHETIC"
    ],
    "REFLECTIVE": [
        "AESTHETIC",
        "VISIBILITY",
        "LIGHTWEIGHT",
        "PERFORMANCE"
    ],
    "ROAD-BIKE": [
        "AESTHETIC"
    ],
    "SADDLE": [
        "AESTHETIC"
    ],
    "SADDLE-BAG": [
        "AESTHETIC"
    ],
    "SEAT-POST": [
        "AESTHETIC"
    ],
    "SHOE": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "SHOE-INSOLE",
        "SHOE-SOLE",
        "SHOE-UPPER",
        "BREATHABLE"
    ],
    "SHOE-COVER": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "INSULATION",
        "PERFORMANCE",
        "BREATHABLE"
    ],
    "SHORT": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "SHORT-SLEEVE-JERSEY": [
        "AESTHETIC",
        "COMFORT",
        "WICKING",
        "PERFORMANCE",
        "BREATHABLE"
    ],
    "SINGLE-SPEED-BIKE": [
        "AESTHETIC"
    ],
    "SKINSUIT": [
        "AESTHETIC"
    ],
    "SOCK": [
        "AESTHETIC",
        "WICKING",
        "COMFORT",
        "BREATHABLE"
    ],
    "SPORTS-BRA": [
        "AESTHETIC"
    ],
    "STEERING": [
        "AESTHETIC"
    ],
    "STEMS": [
        "AESTHETIC"
    ],
    "SUNGLASSES": [
        "AESTHETIC",
        "PROTECTION",
        "LENS",
        "DURABLE",
        "VENTILATION"
    ],
    "SWEATER": [
        "AESTHETIC"
    ],
    "T-SHIRT": [
        "AESTHETIC",
        "COMFORT",
        "PERFORMANCE",
        "BREATHABLE",
        "WICKING"
    ],
    "TANK-TOP": [
        "AESTHETIC",
        "COMFORT",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "THERMAL": [
        "AESTHETIC"
    ],
    "THERMAL-BIB-TIGHT": [
        "AESTHETIC",
        "COMFORT",
        "CHAMOIS",
        "INSULATION",
        "WICKING",
        "QUICK-DRY"
    ],
    "TIGHT": [
        "AESTHETIC"
    ],
    "TOOLS": [
        "AESTHETIC"
    ],
    "TRACK-BIKE": [
        "AESTHETIC"
    ],
    "TROUSER": [
        "AESTHETIC",
        "COMFORT",
        "PROTECTION",
        "POCKET",
        "PERFORMANCE"
    ],
    "TURBO-TRAINER": [
        "AESTHETIC"
    ],
    "UNDERWEAR": [
        "AESTHETIC",
        "COMFORT",
        "PERFORMANCE",
        "WICKING",
        "BREATHABLE"
    ],
    "URBAN-BIKE": [
        "AESTHETIC"
    ],
    "VEST": [
        "AESTHETIC"
    ],
    "WALLET": [
        "AESTHETIC"
    ],
    "WATCH": [
        "AESTHETIC"
    ],
    "WATER-BOTTLE": [
        "AESTHETIC"
    ],
    "WHEEL": [
        "AESTHETIC",
        "DURABLE",
        "LIGHTWEIGHT",
        "CONNECTIVITY",
        "PERFORMANCE",
        "CLOSURE"
    ]
}

export default defaultFeatureTypes



// WEBPACK FOOTER //
// ./src/enums/defaultFeatureTypes.js